import { useState } from 'react'
import { ClipboardDocumentIcon, CheckIcon } from '@heroicons/react/24/outline'
import { shortFp } from './fleet'

/** A runtime fingerprint shown short, with a button that copies all of it. */
export default function Fingerprint({ value, partial = false, className = '' }: { value: string | null | undefined; partial?: boolean; className?: string }) {
  const [copied, setCopied] = useState(false)
  if (!value) return <span className={`font-mono text-slate-400 ${className}`}>no runtime</span>
  const copy = async (e: React.MouseEvent) => {
    e.stopPropagation()
    try {
      await navigator.clipboard.writeText(value)
      setCopied(true)
      window.setTimeout(() => setCopied(false), 1500)
    } catch {
      // Clipboard blocked; the full value is in the tooltip.
    }
  }
  return (
    <span className={`inline-flex items-center gap-1 font-mono ${className}`} title={value}>
      {shortFp(value)}
      {partial && <span className="font-sans text-[10px] px-1 rounded bg-amber-50 text-amber-700">partial</span>}
      <button
        type="button"
        onClick={copy}
        onKeyDown={(e) => e.stopPropagation()}
        className="p-0.5 rounded text-slate-400 hover:text-slate-700 hover:bg-slate-100"
        aria-label={copied ? 'Fingerprint copied' : `Copy fingerprint ${value}`}
      >
        {copied ? <CheckIcon className="w-3.5 h-3.5 text-emerald-600" /> : <ClipboardDocumentIcon className="w-3.5 h-3.5" />}
      </button>
    </span>
  )
}
